import { render } from "./QuotationList_client.vue?vue&type=template&id=42bf2201"
import script from "./QuotationList_client.vue?vue&type=script&lang=js"
export * from "./QuotationList_client.vue?vue&type=script&lang=js"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__